// extracted by mini-css-extract-plugin
module.exports = {"root":"css_root__2-IYC","column":"css_column__1Iw21","cell":"css_cell__2byVR"};